export default class Aircraft {
  constructor({
    type = '',
    country,
    manufacturer,
    years,
    spd,
    man,
    alt,
    roc,
    rob,
    siz,
    other,
    gun,
    ammoLimit,
    front,
    right,
    left,
    rear,
  }) {
    this.type = type;
    this.country = country;
    this.manufacturer = manufacturer;
    this.years = years;
    this.spd = spd;
    this.man = man;
    this.alt = alt;
    this.roc = roc;
    this.rob = rob;
    this.siz = siz;
    this.other = other;
    this.gun = gun;
    this.ammoLimit = ammoLimit;
    this.front = front;
    this.right = right;
    this.left = left;
    this.rear = rear;
  }

  get ammoLimitAsNumber() {
    if (this.ammoLimit == null || this.ammoLimit === 'N/A') {
      return null;
    }
    try {
      return Number.parseInt(this.ammoLimit, 10);
    } catch (e) {
      return null;
    }
  }

  toJSON() {
    return JSON.stringify(this);
  }

  static fromJSON(json) {
    return new Aircraft(json);
  }
}
